export function arrayRange(from, to) {
    return Array.from(Array(Math.max(0, to - from + 1)), (_o, idx) => idx + from);
}
